import toggleScroll from '../utils/toggleScroll';

export default () => {
  $('.form-send').submit((e) => {
    e.preventDefault();
    const $current = $(e.currentTarget);
    const metrikaData = $current.attr('data-ym');

    $.ajax({
      type: 'POST',
      url: 'mail/mail.php',
      data: $current.serializeArray(),
    }).done((data) => {
      const $popupActive = $('.popup--active');
      if ($popupActive.length) {
        $('.popup--active').removeClass('popup--active');
      } else {
        toggleScroll();
      }

      const $popupThanks = $('.popup-thanks');
      $popupThanks.addClass('popup--active');

      setTimeout(() => {
        $current.trigger('reset');
      }, 1000);

      if (metrikaData && typeof YANDEXMETRIKAID !== 'undefined') {
        // eslint-disable-next-line no-undef
        ym(YANDEXMETRIKAID, 'reachGoal', metrikaData);
      }
      console.log(data);
    });
    return false;
  });
};
